import React, { Suspense } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { selectShowTNDevtools } from '@/state/general/generalSelectors';
import { queryClient } from '@/lib/query/queryClient';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const ReactQueryDevtoolsProduction = React.lazy(() =>
    import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
        default: d.ReactQueryDevtools,
    })),
);
const QueryProvider = ({ children }) => {
    const isDevToolsVisible = useSelector((state: RootState) => selectShowTNDevtools(state));

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {isDevToolsVisible && (
                <Suspense fallback={null}>
                    <ReactQueryDevtoolsProduction />
                </Suspense>
            )}
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};

export default QueryProvider;
